<template>
  <b-modal
      class="modal-view-employee-postion"
      id="modal-view-employee-postion"
      hide-footer
      top
      size="xl"
      title="View Detail Employee"
    >
    <div>
      <h6 class="p-2">List {{ title }} </h6>
      <b-row v-show="!employees.length">
          <b-col>
            <div align="center">
            <img src="@/assets/icon-no-invoice.png"/>
          </div>
          </b-col>
        </b-row>
      <b-table striped
        v-show="employees.length"
        :fields="fields"
        :items="listEmployees"
        :per-page="perPage"
        :current-page="currentPage"
        responsive
        ref="table"
        class="p-2"
        @change="$refs.table.refresh()"
      >
      </b-table>
      <div class="d-flex justify-content-between">
        <div>
          <span>Show</span>
          <b-form-select
            v-model="perPage"
            :options="pageOptions"
            @change="$refs.table.refresh()"
            class="page-option ml-2 mr-2 w-auto"
            size="sm"
          />
          <span>Entries</span>
        </div>
        <div>
          <b-pagination
            class="mb-0"
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
            pills
            hide-goto-end-buttons
          />
          <span class="show-entries mr-auto">
            {{
            `Show ${
              totalRows === 0 ? 0 : (currentPage - 1) * perPage + 1
            } to ${
              totalRows > currentPage * perPage
                ? currentPage * perPage
                : totalRows
            } of ${totalRows} entries`
          }}
          </span>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'TableCategoryEmployee',
  props: {
    employees: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      fields: [],
      listEmployeesPerPostion: [],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      totalPage: 0,
      pageOptions: [10, 20, 50, 100]
    }
  },
  watch: {
    title: {
      handler(newTitle) {
        if (newTitle === 'Resigned Employee') {
          this.fields = [
            { key: 'employeeNo', label: 'ID', tdClass: 'text-center', thClass: 'text-center' },
            { key: 'fullName', label: 'Name', tdClass: 'text-center', thClass: 'text-center' },
            { key: 'email', label: 'Email', tdClass: 'text-center', thClass: 'text-center' },
            { key: 'phoneNumber', label: 'Phone Number', tdClass: 'text-center', thClass: 'text-center' },
            { key: 'hireDate', label: 'Hire Date', tdClass: 'text-center', thClass: 'text-center' },
            { key: 'resignDate', label: 'Resign Date', tdClass: 'text-center', thClass: 'text-center' }
          ]
        } else if (newTitle === 'Contract Employee' || newTitle === 'Probation Employee') {
          this.fields = [
            { key: 'employeeNo', label: 'ID', tdClass: 'text-center', thClass: 'text-center' },
            { key: 'fullName', label: 'Name', tdClass: 'text-center', thClass: 'text-center' },
            { key: 'email', label: 'Email', tdClass: 'text-center', thClass: 'text-center' },
            { key: 'phoneNumber', label: 'Phone Number', tdClass: 'text-center', thClass: 'text-center' },
            { key: 'hireDate', label: 'Hire Date', tdClass: 'text-center', thClass: 'text-center' },
            { key: 'resignDate', label: 'End Date', tdClass: 'text-center', thClass: 'text-center' }
          ]
        } else {
          this.fields = [
            { key: 'employeeNo', label: 'ID', tdClass: 'text-center', thClass: 'text-center' },
            { key: 'fullName', label: 'Name', tdClass: 'text-center', thClass: 'text-center' },
            { key: 'email', label: 'Email', tdClass: 'text-center', thClass: 'text-center' },
            { key: 'phoneNumber', label: 'Phone Number', tdClass: 'text-center', thClass: 'text-center' },
            { key: 'hireDate', label: 'Hire Date', tdClass: 'text-center', thClass: 'text-center' },
            { key: 'yearsWorking', label: 'Years Working', tdClass: 'text-center', thClass: 'text-center' }
          ]
        }
      }
    }
  },
  methods: {
    listEmployees() {
      const currentDate = new Date()
      this.listEmployeesPerPostion = this.employees.map((employee, index) => {
        if (employee.resignDate < this.formatedDate(currentDate)) {
          return {
            employeeNo: employee.employeeNo,
            fullName: employee.fullName,
            email: employee.email,
            phoneNumber: employee.phoneNumber,
            hireDate: employee.hireDate,
            resignDate: employee.resignDate,
            status: employee.status,
            _rowVariant: index % 2 === 0 ? 'warning' : null,
            yearsWorking: this.yearsWorking(employee.hireDate)
          }
        } else {
          return {
            employeeNo: employee.employeeNo,
            fullName: employee.fullName,
            email: employee.email,
            phoneNumber: employee.phoneNumber,
            hireDate: employee.hireDate,
            status: employee.status,
            resignDate: employee.resignDate,
            _rowVariant: index % 2 === 0 ? 'warning' : null,
            yearsWorking: this.yearsWorking(employee.hireDate)
          }
        }
      })
      this.totalRows = this.employees.length
      this.totalPage = Math.ceil(this.totalRows / this.perPage)
      return this.listEmployeesPerPostion.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      )
    },
    formatedDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    yearsWorking(hireDate) {
      const currentDate = new Date()
      const date = new Date(hireDate)
      const year = currentDate.getFullYear() - date.getFullYear()
      const month = currentDate.getMonth() - date.getMonth()
      const day = currentDate.getDate() - date.getDate()
      return `${year} Year ${month} Month ${day} Day`
    }
  }
}
</script>
